export enum SubscriptionType {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
}

export enum SubscriptionStatus {
  FINISHED = 'FINISHED',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}
